export default ({ legalStatus }) => ({
  legalStatus: legalStatus || '',
  description: ''
});
